

export const FETCH_MEETING_REQUEST = 'FETCH_MEETING_REQUEST';
export const FETCH_MEETING_REQUEST_COMPLETED = 'FETCH_MEETING_REQUEST_COMPLETED';
export const FETCH_MEETING_REQUEST_ERROR = 'FETCH_MEETING_REQUEST_ERROR';
export const FETCH_MEETING_RESET = 'FETCH_MEETING_RESET';

export const FETCH_MEETING_LIST_REQUEST = 'FETCH_MEETING_LIST_REQUEST';
export const FETCH_MEETING_LIST_REQUEST_COMPLETED = 'FETCH_MEETING_LIST_REQUEST_COMPLETED';
export const FETCH_MEETING_LIST_REQUEST_ERROR = 'FETCH_MEETING_LIST_REQUEST_ERROR';
export const FETCH_MEETING_LIST_RESET = 'FETCH_MEETING_LIST_RESET';

export const FETCH_SWITCH_MEETING_LIST_REQUEST = 'FETCH_SWITCH_MEETING_LIST_REQUEST';
export const FETCH_SWITCH_MEETING_LIST_REQUEST_COMPLETED = 'FETCH_SWITCH_MEETING_LIST_REQUEST_COMPLETED';
export const FETCH_SWITCH_MEETING_LIST_REQUEST_ERROR = 'FETCH_SWITCH_MEETING_LIST_REQUEST_ERROR';

export const ADD_MEETING_INITIAL = 'ADD_MEETING_INITIAL';
export const ADD_MEETING_REQUEST = 'ADD_MEETING_REQUEST';
export const ADD_MEETING_REQUEST_COMPLETED = 'ADD_MEETING_REQUEST_COMPLETED';
export const ADD_MEETING_REQUEST_ERROR = 'ADD_MEETING_REQUEST_ERROR';


export const ADD_MEETING_MINUTES_FILE_INITIAL = 'ADD_MEETING_MINUTES_FILE_INITIAL';
export const ADD_MEETING_MINUTES_FILE_REQUEST = 'ADD_MEETING_MINUTES_FILE_REQUEST';
export const ADD_MEETING_MINUTES_FILE_REQUEST_COMPLETED = 'ADD_MEETING_MINUTES_FILE_REQUEST_COMPLETED';
export const ADD_MEETING_MINUTES_FILE_REQUEST_ERROR = 'ADD_MEETING_MINUTES_FILE_REQUEST_ERROR';

export const UPDATE_MM_FILE_REQUEST = 'UPDATE_MM_FILE_REQUEST';
export const UPDATE_MM_FILE_REQUEST_COMPLETED = 'UPDATE_MM_FILE_REQUEST_COMPLETED';
export const UPDATE_MM_FILE_REQUEST_ERROR = 'UPDATE_MM_FILE_REQUEST_ERROR';

export const DELETE_MM_FILE_REQUEST = 'DELETE_MM_FILE_REQUEST';
export const DELETE_MM_FILE_REQUEST_COMPLETED = 'DELETE_MM_FILE_REQUEST_COMPLETED';
export const DELETE_MM_FILE_REQUEST_ERROR = 'DELETE_MM_FILE_REQUEST_ERROR';


export const SEND_MEETING_MINUTES_NOTIFY_REQUEST = 'SEND_MEETING_MINUTES_NOTIFY_REQUEST';
export const SEND_MEETING_MINUTES_NOTIFY_REQUEST_COMPLETED = 'SEND_MEETING_MINUTES_NOTIFY_REQUEST_COMPLETED';
export const SEND_MEETING_MINUTES_NOTIFY_REQUEST_ERROR = 'SEND_MEETING_MINUTES_NOTIFY_REQUEST_ERROR';


// WEBPACK FOOTER //
// ./constants/meetingdetails.js